import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-order-success',
  imports: [DatePipe, CommonModule],
  templateUrl: './order-success.component.html',
  styleUrl: './order-success.component.scss'
  // providers: [DatePipe]
})
export class OrderSuccessComponent implements OnInit, AfterViewInit {
  @ViewChild('successHeading') successHeading!: ElementRef;
  orderDate: any = Date.now();
  state: any;
  
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.state = history.state;
     if (!this.state || !this.state.orderNumber) {
      this.router.navigate(['/home/landing-page']);
      return;
    }
  }

  // add focus to the top
  ngAfterViewInit() {
    setTimeout(() => {
      this.successHeading.nativeElement.focus();
    });
  }

}
